import { configureStore } from '@reduxjs/toolkit';

import viewReducer from 'src/react/recommendations/store/slices/view';
import tasksReducer from 'src/react/recommendations/store/slices/tasks';
import ideasReducer from 'src/react/recommendations/store/slices/ideas';
import modalReducer from 'src/react/recommendations/store/slices/modal';
import settingsReducer from 'src/react/recommendations/store/slices/settings';

export default configureStore({
  reducer: {
    view: viewReducer,
    tasks: tasksReducer,
    ideas: ideasReducer,
    modal: modalReducer,
    settings: settingsReducer
  }
});
